// Central testId registry for Kraft-Performance landing feature.
export const KRAFT = {
  // Header
  headerRoot: 'header-root',
  headerLogo: 'header-logo',
  headerPhone1: 'header-phone-1',
  headerPhone2: 'header-phone-2',
  headerCtaEmergency: 'header-cta-emergency',
  headerNavAbout: 'header-nav-about',
  headerNavServices: 'header-nav-services',
  headerNavCertificates: 'header-nav-certificates',
  headerNavHours: 'header-nav-hours',
  headerNavGallery: 'header-nav-gallery',
  headerNavBooking: 'header-nav-booking',
  headerNavContact: 'header-nav-contact',

  // Hero
  heroRoot: 'hero-root',
  heroBadge247: 'hero-badge-247',
  heroCtaPrimary: 'hero-cta-primary',
  heroCtaSecondary: 'hero-cta-secondary',
  heroScrollHint: 'hero-scroll-hint',

  // Marquee
  marqueeRoot: 'marquee-root',

  // Manifesto
  manifestoRoot: 'manifesto-root',
  manifestoChapter: (idx) => `manifesto-chapter-${idx}`,

  // Certificates
  certificatesRoot: 'certificates-root',
  certificateCard: (id) => `certificate-card-${id}`,

  // Business Hours
  hoursRoot: 'hours-root',
  hoursEmergencyNote: 'hours-emergency-note',
  hoursMapLink: 'hours-map-link',

  // Booking
  bookingRoot: 'booking-root',
  bookingCalendar: 'booking-calendar',
  bookingSlot: (slot) => `booking-slot-${slot.replace(':', '-')}`,
  bookingInputName: 'booking-input-name',
  bookingInputEmail: 'booking-input-email',
  bookingInputPhone: 'booking-input-phone',
  bookingInputService: 'booking-input-service',
  bookingInputAddress: 'booking-input-address',
  bookingInputNotes: 'booking-input-notes',
  bookingSubmit: 'booking-submit',

  // Contact
  contactRoot: 'contact-root',
  contactInputName: 'contact-input-name',
  contactInputEmail: 'contact-input-email',
  contactInputPhone: 'contact-input-phone',
  contactInputSubject: 'contact-input-subject',
  contactInputMessage: 'contact-input-message',
  contactSubmit: 'contact-submit',
  contactFacebookLink: 'contact-facebook-link',

  // Footer
  footerRoot: 'footer-root',
  footerAdminLink: 'footer-admin-link',
  footerFacebookLink: 'footer-facebook-link',
  footerAgencyLink: 'footer-agency-link',

  // Services
  servicesRoot: 'services-root',
  serviceCard: (id) => `service-card-${id}`,

  // Gallery
  galleryRoot: 'gallery-root',
  galleryItem: (idx) => `gallery-item-${idx}`,
  galleryLightbox: 'gallery-lightbox',
  galleryLightboxClose: 'gallery-lightbox-close',
  galleryLightboxPrev: 'gallery-lightbox-prev',
  galleryLightboxNext: 'gallery-lightbox-next',
  galleryFacebookCta: 'gallery-facebook-cta',

  // Admin
  adminRoot: 'admin-root',
  adminLoginRoot: 'admin-login-root',
  adminLoginEmail: 'admin-login-email',
  adminLoginPassword: 'admin-login-password',
  adminLoginSubmit: 'admin-login-submit',
  adminLoginError: 'admin-login-error',
  adminLogout: 'admin-logout',
  adminUserBadge: 'admin-user-badge',
  adminTabBookings: 'admin-tab-bookings',
  adminTabMessages: 'admin-tab-messages',
  adminRefresh: 'admin-refresh',
  adminBookingRow: (id) => `admin-booking-row-${id}`,
  adminMessageRow: (id) => `admin-message-row-${id}`,
  adminStatusSelect: (id) => `admin-status-select-${id}`,
  adminStatusOption: (status) => `admin-status-option-${status}`,
  adminDeleteBooking: (id) => `admin-delete-booking-${id}`,
  adminDeleteMessage: (id) => `admin-delete-message-${id}`,
  adminDeleteConfirm: 'admin-delete-confirm',
  adminDeleteCancel: 'admin-delete-cancel',
};
